/* UploadImageProgressComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./UploadImageProgressRenderer");

/**
 * A CreateFileProgressComponent namespace.
 * @namespace CreateFileProgress
 */

/**
 * @class CreateFileProgressComponent
 * @extends EventEmitter
 *
 * @fires CreateFileProgressComponent#Shutdown
 * @fires CreateFileProgressComponent#Progress
 *
 */
class UploadImageProgressComponent extends EventEmitter {
    constructor() {
        super();

        this._registerListeners();
        this._renderer = new Renderer(this);
        this.data = [];
    }
    get renderer() {
        return this.getRenderer();
    }
    get rootElem() {
        return this._renderer.getRootElement();
    }

    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}

    _triggerShutdown() {
        /**
         * @event CreateFileProgressComponent#Shutdown
         * @param {CreateFileProgressComponent}
         */
        this.emit("Shutdown", this);
    }

    _triggerProgress(progressData) {
        /**
         * @event CreateFileProgressComponent#Progress
         * @param {Object}
         */
        this.emit("Progress", progressData);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._triggerShutdown();
        this._unregisterListeners();
        const shutDowns = [this._renderer?.shutdown() || Promise.resolve()];

        return Promise.all(shutDowns).then(
            () => {
                this.removeAllListeners();
                this._renderer = undefined;
            },
            (/*err*/) => {}
        );
    }

    reject(error) {
        this._context.reject(error);
    }
    resolve(data) {
        this._context.resolve(data);
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    abortProgress() {
        this.reject({aborted: true});
    }
    close() {
        this.resolve({closed: true});
    }

    setData(filesData) {
        this.filesData = filesData.map(({id, name, fileSize: size, fileType, type}) => ({
            name,
            size,
            fileType,
            type,
            id,
        }));

        this.totalAmount = this.filesData.length;
        this.totalSize = this.filesData.reduce((sum, {size}) => sum + size || 0, 0);
    }

    setProgress(idx, bytesUploaded, bytesTotal) {
        const currentPercentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
        this._triggerProgress({
            fileNo: idx + 1,
            filesTotal: this.totalAmount,
            currentPercentage,
        });
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = UploadImageProgressComponent;
